import Icon from '../components/Icon.vue'

Icon.register({
  road: {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M573.2 402.7L433.4 82.7C428.4 71.3 417.6 64 405.7 64H308.1L310.5 87.2C311 91.9 307.3 96 302.6 96H273.4C268.7 96 265 91.9 265.5 87.2L267.9 64H170.3C158.4 64 147.6 71.3 142.6 82.7L2.8 402.7C-6.5 423.9 8.3 448 30.5 448H227.4L237.7 350.3C238.6 342.2 245.4 336 253.6 336H322.4C330.6 336 337.4 342.2 338.3 350.3L348.6 448H545.5C567.7 448 582.5 423.9 573.2 402.7zM260.4 135.2A8-8 0 0 0 268.4 128H307.6C311.7 128 315.2 131.1 315.6 135.2L320.2 178.7C321 185.8 315.4 192 308.3 192H267.7C260.6 192 255.1 185.8 255.8 178.7L260.4 135.2zM315.6 304H260.4C250.8 304 243.4 295.8 244.4 286.3L249.5 238.3C250.4 230.2 257.2 224 265.4 224H310.6C318.8 224 325.6 230.2 326.5 238.3L331.6 286.3C332.6 295.8 325.1 304 315.6 304z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/road.js
// module id = XC/n
// module chunks = 144